import React from 'react'
import 'react-notifications/lib/notifications.css'
import { NotificationManager } from 'react-notifications'

const Notification = (props) => {
  const { data, type, message, notificationTitle } = props
  let response = {}
  if (data && data.response) {
    // Errors
    if (data.response.status === 422) {
      let messages = []
      if (data.response.data.errors) {
        messages = Object.values(data.response.data.errors)
      } else {
        messages = Object.values(data.response.data.data)
      }
      response = {
        type: 'error',
        message: messages[0][0],
      }
    }
    if (data.response.status === 500) {
      response = {
        type: 'error',
        message: 'An error occurred while processing the action',
      }
    }
    if (data.response.status === 401) {
      response = {
        type: 'error',
        message: data.response.data.message,
      }
    }
    // EO Errors
  }

  let notification = <div />
  let notificationType = response.type
  let notificationMessage = response.message
  if (type) {
    notificationType = type
    notificationMessage = message
  }

  switch (notificationType) {
    case 'info':
      notification = NotificationManager.info(
        notificationMessage,
        notificationTitle,
        3000
      )
      break
    case 'success':
      notification = NotificationManager.success(
        notificationMessage,
        notificationTitle,
        3000
      )
      break
    case 'warning':
      notification = NotificationManager.warning(
        'Warning message',
        'Close after 3000ms',
        3000
      )
      break
    case 'error':
      notification = NotificationManager.error(
        notificationMessage,
        notificationTitle ? notificationTitle : 'Error!',
        5000
      )
      break
  }

  return <div>{notification}</div>
}

export default Notification
